import { useState } from "react";

import { GetApp } from "@material-ui/icons";
import { Popover } from "antd";
import styled from "styled-components";
import { ExportFormat } from "utils/exportUtils";

import { Tooltip } from "components/base";
import { IconSpinner } from "components/icons";

import { ActionButton } from "./ActionButton";

interface ExportIconButtonProps {
  tooltip: string;
  loading?: boolean;
  iconSizePx?: number;
  onSelect: (format: ExportFormat) => void;
  "data-testid"?: string;
}

export const ExportIconButton = ({
  tooltip,
  loading = false,
  iconSizePx,
  onSelect,
  "data-testid": testId
}: ExportIconButtonProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  const iconStyle = iconSizePx == null ? undefined : { fontSize: iconSizePx };

  const select = (format: ExportFormat) => {
    onSelect(format);
    setOpen(false);
  };

  return (
    <Popover
      overlayClassName="export-popover"
      placement="bottomLeft"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      content={
        <ExportContainer>
          <ExportMenuButton
            type="button"
            disabled={loading}
            data-testid="export-to-csv-button"
            onClick={() => select(ExportFormat.CSV)}>
            <GetApp fontSize="large" />
            <span className="button-text">Export to CSV (.csv)</span>
          </ExportMenuButton>
          <ExportMenuButton
            type="button"
            disabled={loading}
            data-testid="export-to-excel-button"
            onClick={() => select(ExportFormat.Excel)}>
            <GetApp fontSize="large" />
            <span className="button-text">Export to Excel (.xlsx)</span>
          </ExportMenuButton>
        </ExportContainer>
      }>
      <Tooltip title={tooltip}>
        <ActionButton type="button" aria-label={tooltip} data-testid={testId}>
          {loading ? <IconSpinner /> : <GetApp fontSize="large" style={iconStyle} />}
        </ActionButton>
      </Tooltip>
    </Popover>
  );
};

const ExportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  font-size: 1.4rem;
  font-weight: var(--fontWeightMedium);
  position: relative;
`;

const ExportMenuButton = styled.button`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 200px;
  flex-shrink: 0;
  background-color: white;
  border: none;
  background: none;
  cursor: pointer;

  &:hover {
    background-color: var(--color-accent-hover);
    color: var(--color-text);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .button-text {
    display: inline-flex;
    cursor: pointer;
    padding-top: 14px;
    padding-bottom: 13px;
    padding-left: 10px;
    vertical-align: sub;
  }
`;
